export default function(request, reject, rootAddress) {
  var service = {};
  /**
		获取上传图片的token
		请求方法: GET, POST
		请求示例: http://<domain>/jxmobile2/nielian181210/get_upload_token?id=1&type=1

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "action": "http://up.qiniu.com",
	        "input_file_name": "file",
	        "input_values": {
	            "token": "AUsWmwjd0VwZJP8mIH7jlMlR0Iy-YwqRGivBrYfp:fgtOon0UAEqK0cvrvg_QGy6nHCA=:eyJyZXR1cm5VcmwiOiIiLCJyZXR1cm5Cb2R5Ijoie30iLCJjYWxsYmFja0hvc3QiOiIiLCJjYWxsYmFja1VybCI6Imh0dHA6XC9cL3RhbS50dW5uZWwucXlkZXYuY29tXC9jb3JlXC91cGxvYWRcL3Fpbml1X2NhbGxiYWNrIiwiY2FsbGJhY2tCb2R5IjoiYnVuZGxlPWp4M3p0JmZpbGVfaWQ9MjQxNzE2ZDdhNGYzZTYzNTM3ODFlNDI2MTllYWRjOTcmZmlsZV9uYW1lPSQoZm5hbWUpJmZpbGVfc2l6ZT0kKGZzaXplKSZmaWxlX21pbWVfdHlwZT0kKG1pbWVUeXBlKSZmaWxlX2hhc2g9JChldGFnKSIsImluc2VydE9ubHkiOjEsImRldGVjdE1pbWUiOjEsImZzaXplTGltaXQiOjUyNDI4ODAsIm1pbWVMaW1pdCI6ImltYWdlXC9qcGVnO2ltYWdlXC9qcGVnO2ltYWdlXC9naWY7aW1hZ2VcL3BuZzt2aWRlb1wvbXA0O3ZpZGVvXC93ZWJtO3ZpZGVvXC9xdWlja3RpbWUiLCJzY29wZSI6Inhzamd3Omp4M3p0XC9qeDNcL2RtamgxNzExMzBcL2VkXC80N1wvZWQ0NzEzNGJmZDIxMjE5MmUxN2I4ZDI5NmMyMjRkOWIiLCJkZWFkbGluZSI6MTUxMjA0NzQ1OH0=",
	            "key": "jx3zt/jx3/dmjh171130/ed/47/ed47134bfd212192e17b8d296c224d9b",
	            "domain": "http://7xq4h6.com1.z0.glb.clouddn.com"
	        },
	        "session_id": "afebfbf476b36382386729cc6b7107da95e07eee",
	        "request_id": "66fc148cd8529a531e99432b5d3a3d025205015a"
	    }
	 }
		*/
  service.getUploadToken = function(id, type) {
    return request.jsonp(rootAddress + '/jxmobile2/nielian181210/get_upload_token', {
      id: id /*  作品序号(1, 2) */ ,
      type: type /*  上传类型 1成女 2萝莉 3正太 4成男 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)",
            "action": "上传地址",
            "input_file_name": "上传input:file的name名称",
            "input_values": "上传表单项"
          },
          "data{}.input_values{}": {
            "domain": "空间域名",
            "key": "上传文件KEY",
            "token": "上传文件TOKEN"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10701",
        "description": "未知驱动"
      }, {
        "code": "-10801",
        "description": "请先微信授权"
      }, {
        "code": "-20201",
        "description": "id不合法"
      }, {
        "code": "-20202",
        "description": "上传类型不合法"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		提交作品集
		请求方法: GET, POST
		请求示例: http://<domain>/jxmobile2/nielian181210/submit_gallery?title=测试&data=xxxx&category=2&tags[0]=标签1&tags[1]=标签2&game_nickname=角色昵称&upload_items[0][file_id]=52f7ba56e5a5c13b0441e21798825955&upload_items[0][type]=1&upload_items[1][file_id]=52f7ba56e5a5c13b0441e21798825955&upload_items[1][type]=2&zone_name=测试区&server_name=测试服&role_id=xxxxx

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "o2AZT2NhFLfhCJpC851WhwnUznVUdvPZYaMYUDVb",
	        "request_id": "28b1618df768822a3e3833a31f10ce67945b7f29"
	    }
	 }
		*/
  service.submitGallery = function(category, data, game_nickname, role_id, server_name, tags, title, upload_items, zone_name) {
    return request.jsonp(rootAddress + '/jxmobile2/nielian181210/submit_gallery', {
      category: category /*  捏脸类别 1成女 2萝莉 3正太 4成男 */ ,
      data: data /*  作品数据 */ ,
      game_nickname: game_nickname /*  角色昵称 */ ,
      role_id: role_id /*  角色id */ ,
      server_name: server_name /*  服名称 */ ,
      tags: tags /*  标签数组 */ ,
      title: title /*  作品标题 */ ,
      upload_items: upload_items /*  上传数组(见后置说明) */ ,
      zone_name: zone_name /*  区名称 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10801",
        "description": "请先微信授权"
      }, {
        "code": "-20101",
        "description": "标题为空"
      }, {
        "code": "-20102",
        "description": "脸型数据为空"
      }, {
        "code": "-20103",
        "description": "标签为空"
      }, {
        "code": "-20104",
        "description": "请输入2个数量的标签"
      }, {
        "code": "-20105",
        "description": "游戏昵称为空"
      }, {
        "code": "-20106",
        "description": "上传作品为空"
      }, {
        "code": "-20107",
        "description": "大区名称为空"
      }, {
        "code": "-20108",
        "description": "服务器名称为空"
      }, {
        "code": "-20109",
        "description": "图片类型错误"
      }, {
        "code": "-20110",
        "description": "捏脸体型错误"
      }, {
        "code": "-20111",
        "description": "同一种体型的作品最多只能上传两份哦~"
      }, {
        "code": "-20113",
        "description": "角色id为空"
      }, {
        "code": "-20206",
        "description": "超过能上传图片最大数"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获取作品集列表
		请求方法: GET, POST
		请求示例: http://<domain>/jxmobile2/nielian181210/get_gallery_list?category=1&order_by=1&page_num=1&page_size=10

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "total": 3,
	        "list": [
	            {
	                "id": 6,
	                "title": "测试",
	                "data": "xxxx",
	                "category": 1,
	                "tags": [
	                    "标签1",
	                    "标签2"
	                ],
	                "game_nickname": "",
	                "zone_name": "测试区",
	                "server_name": "测试服",
	                "like": 1,
	                "created_at": "2018-12-11 10:47:30",
	                "type": 2,
	                "pic_link": "http://7xq4h6.com1.z0.glb.clouddn.com/xsjgw/cpanel/9f/ce/9fcedead3c7e333de23e6669c5c4547c",
	                "is_like": 0,
	                "wechat_nickname": "",
	                "wechat_head_img_url": "",
	                "wechat_uid": "e04f8ce2b032b8c913fd6e9087ac7424"
	            },
	            {
	                "id": 5,
	                "title": "测试",
	                "data": "xxxx",
	                "category": 1,
	                "tags": [
	                    "标签1",
	                    "标签2"
	                ],
	                "game_nickname": "",
	                "zone_name": "测试区",
	                "server_name": "测试服",
	                "like": 1,
	                "created_at": "2018-12-10 19:52:40",
	                "type": 2,
	                "pic_link": "http://7xq4h6.com1.z0.glb.clouddn.com/xsjgw/cpanel/9f/ce/9fcedead3c7e333de23e6669c5c4547c",
	                "is_like": 0,
	                "wechat_nickname": "测试昵称",
	                "wechat_head_img_url": "http://wx.qlogo.cn/mmopen/mbdcgRg42DZtROPSTQBEyMRznpc20J6BzusAscCKjVOKVk9QoaCEQlkxAXZFEovCP38uaJKzzPibXeibz5oRs8oopvtkMuscoF/0",
	                "wechat_uid": "e04f8ce2b032b8c913fd6e9087ac7425"
	            },
	            {
	                "id": 4,
	                "title": "测试",
	                "data": "xxxx",
	                "category": 1,
	                "tags": [
	                    "标签1",
	                    "标签2"
	                ],
	                "game_nickname": "",
	                "zone_name": "测试区",
	                "server_name": "测试服",
	                "like": 2,
	                "created_at": "2018-12-10 19:52:03",
	                "type": 2,
	                "pic_link": "http://7xq4h6.com1.z0.glb.clouddn.com/xsjgw/cpanel/9f/ce/9fcedead3c7e333de23e6669c5c4547c",
	                "is_like": 0,
	                "wechat_nickname": "测试昵称",
	                "wechat_head_img_url": "http://wx.qlogo.cn/mmopen/mbdcgRg42DZtROPSTQBEyMRznpc20J6BzusAscCKjVOKVk9QoaCEQlkxAXZFEovCP38uaJKzzPibXeibz5oRs8oopvtkMuscoF/0",
	                "wechat_uid": "e04f8ce2b032b8c913fd6e9087ac7425"
	            }
	        ],
	        "session_id": "HLmPYgzktchnnApcKO2rhOpn5USX3HrImdhmeFRK",
	        "request_id": "cffed4496c87e2485e5ec9309f43cbe8e0f40bbe"
	    }
	 }
		*/
  service.getGalleryList = function(category, order_by, page_num, page_size) {
    return request.jsonp(rootAddress + '/jxmobile2/nielian181210/get_gallery_list', {
      category: category /*  捏脸类别 1成女 2萝莉 3正太 4成男 */ ,
      order_by: order_by /*  排序规则 1时间 2热度 */ ,
      page_num: page_num /*  页数 */ ,
      page_size: page_size /*  分页大小 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)",
            "list": "列表",
            "total": "列表总数"
          },
          "data{}.list[]": {
            "category": "捏脸类别 1成女 2萝莉 3正太 4成男",
            "created_at": "创建时间",
            "data": "作品数据",
            "game_nickname": "角色昵称",
            "id": "ID",
            "is_like": "是否点过赞 0否 1是",
            "like": "点赞数",
            "pic_link": "图片链接",
            "server_name": "服名称",
            "tags": "标签组",
            "title": "作品标题",
            "type": "类别 1商城正面截图 2游戏内时装截图",
            "wechat_head_img_url": "微信头像地址",
            "wechat_nickname": "微信头像昵称",
            "wechat_uid": "微信uid",
            "zone_name": "区名称"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10701",
        "description": "未知驱动"
      }, {
        "code": "-10801",
        "description": "请先微信授权"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获取我的作品集
		请求方法: GET, POST
		请求示例: http://<domain>/jxmobile2/nielian181210/get_my_gallery?category=1&status=1

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "list": [
	            {
	                "id": 7,
	                "title": "测试",
	                "data": "xxxx",
	                "category": 1,
	                "tags": [
	                    "标签1",
	                    "标签2"
	                ],
	                "game_nickname": "",
	                "zone_name": "测试区",
	                "server_name": "测试服",
	                "like": 0,
	                "created_at": "2018-12-11 10:50:09",
	                "award_type": 0,
	                "status": 0,
	                "type": 1,
	                "pic_link": "http://7xq4h6.com1.z0.glb.clouddn.com/xsjgw/cpanel/9f/ce/9fcedead3c7e333de23e6669c5c4547c",
	                "is_like": 0,
	                "wechat_nickname": "",
	                "wechat_head_img_url": "",
	                "wechat_uid": "e04f8ce2b032b8c913fd6e9087ac7424"
	            }
	        ],
	        "total": 1,
	        "total_like": 0,
	        "session_id": "Tx3DiRWF9Nq7H4s8Wq3NgFOZ719X9G89ObhqdnU5",
	        "request_id": "fa503eb9f453fb8084fd0aab01f3075f65797a16"
	    }
	 }
		*/
  service.getMyGallery = function(category, status) {
    return request.jsonp(rootAddress + '/jxmobile2/nielian181210/get_my_gallery', {
      category: category /*  捏脸类别 1成女 2萝莉 3正太 4成男 */ ,
      status: status /*  状态 -1审核不通过 0审核中 1审核通过 不传为获取全部 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)",
            "list": "列表",
            "total": "列表总数",
            "total_like": "全部作品总点赞数"
          },
          "data{}.list[]": {
            "award_type": "是否获奖作品 0没有获奖 1优秀奖 2人气奖",
            "category": "捏脸类别 1成女 2萝莉 3正太 4成男",
            "created_at": "创建时间",
            "data": "作品数据",
            "game_nickname": "角色昵称",
            "id": "ID",
            "is_like": "是否点过赞 0否 1是",
            "like": "点赞数",
            "pic_link": "图片链接",
            "server_name": "服名称",
            "status": "状态 -1审核不通过 0审核中 1审核通过",
            "tags": "标签组",
            "title": "作品标题",
            "type": "类别 1商城正面截图 2游戏内时装截图",
            "wechat_head_img_url": "微信头像地址",
            "wechat_nickname": "微信头像昵称",
            "wechat_uid": "微信uid",
            "zone_name": "区名称"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10701",
        "description": "未知驱动"
      }, {
        "code": "-10801",
        "description": "请先微信授权"
      }, {
        "code": "-20110",
        "description": "捏脸体型错误"
      }, {
        "code": "-20301",
        "description": "审核状态不合法"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		根据作品集id获取作品详情
		请求方法: GET, POST
		请求示例: http://<domain>/jxmobile2/nielian181210/get_gallery_by_id?gallery_id=4

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "list": [
	            {
	                "id": 4,
	                "title": "测试",
	                "game_nickname": "",
	                "data": "",
	                "category": 1,
	                "tags": [
	                    "标签1",
	                    "标签2"
	                ],
	                "like": 2,
	                "zone_name": "测试区",
	                "server_name": "测试服",
	                "award_type": 1,
	                "status": 1,
	                "pic_link": "http://7xq4h6.com1.z0.glb.clouddn.com/xsjgw/cpanel/9f/ce/9fcedead3c7e333de23e6669c5c4547c",
	                "is_like": 0,
	                "wechat_nickname": "测试昵称",
	                "wechat_head_img_url": "http://wx.qlogo.cn/mmopen/mbdcgRg42DZtROPSTQBEyMRznpc20J6BzusAscCKjVOKVk9QoaCEQlkxAXZFEovCP38uaJKzzPibXeibz5oRs8oopvtkMuscoF/0",
	                "wechat_uid": "e04f8ce2b032b8c913fd6e9087ac7425"
	            },
	            {
	                "id": 4,
	                "title": "测试",
	                "game_nickname": "",
	                "data": "",
	                "category": 1,
	                "tags": [
	                    "标签1",
	                    "标签2"
	                ],
	                "like": 2,
	                "zone_name": "测试区",
	                "server_name": "测试服",
	                "award_type": 1,
	                "status": 1,
	                "pic_link": "http://7xq4h6.com1.z0.glb.clouddn.com/xsjgw/cpanel/9f/ce/9fcedead3c7e333de23e6669c5c4547c",
	                "is_like": 0,
	                "wechat_nickname": "测试昵称",
	                "wechat_head_img_url": "http://wx.qlogo.cn/mmopen/mbdcgRg42DZtROPSTQBEyMRznpc20J6BzusAscCKjVOKVk9QoaCEQlkxAXZFEovCP38uaJKzzPibXeibz5oRs8oopvtkMuscoF/0",
	                "wechat_uid": "e04f8ce2b032b8c913fd6e9087ac7425"
	            }
	        ],
	        "session_id": "kgktDzBJnJQHyF7QomAvjYv87lNWpvPdVQ8NwDlq",
	        "request_id": "ad3067fbc6f742409971d5fca09bb9bcedbb7770"
	    }
	 }
		*/
  service.getGalleryById = function(gallery_id) {
    return request.jsonp(rootAddress + '/jxmobile2/nielian181210/get_gallery_by_id', {
      gallery_id: gallery_id /*  作品集id */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)",
            "list": "列表"
          },
          "data{}.list[]": {
            "award_type": "是否获奖作品 0没有获奖 1优秀奖 2人气奖",
            "category": "捏脸类别 1成女 2萝莉 3正太 4成男",
            "data": "作品数据",
            "game_nickname": "角色昵称",
            "id": "ID",
            "is_like": "是否点过赞 0否 1是",
            "like": "点赞数",
            "pic_link": "图片链接",
            "server_name": "服名称",
            "status": "状态 -1审核不通过 0审核中 1审核通过",
            "tags": "标签组",
            "title": "作品标题",
            "wechat_head_img_url": "微信头像地址",
            "wechat_nickname": "微信头像昵称",
            "wechat_uid": "微信uid",
            "zone_name": "区名称"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10701",
        "description": "未知驱动"
      }, {
        "code": "-10801",
        "description": "请先微信授权"
      }, {
        "code": "-20401",
        "description": "作品集id为空"
      }, {
        "code": "-20402",
        "description": "作品集不存在"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		作品点赞
		请求方法: GET, POST
		请求示例: http://<domain>/jxmobile2/nielian181210/like?gallery_id=4

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "KVolmeIqT1gW5Z1mw9TQ1G6UMJp0r3u1VrMe5zLD",
	        "request_id": "e038d5b2768b4ee484fc950120ee48d71ab7cfa6"
	    }
	 }
		*/
  service.like = function(gallery_id) {
    return request.jsonp(rootAddress + '/jxmobile2/nielian181210/like', {
      gallery_id: gallery_id /*  作品集id */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10801",
        "description": "请先微信授权"
      }, {
        "code": "-20401",
        "description": "作品集id为空"
      }, {
        "code": "-20402",
        "description": "作品集不存在"
      }, {
        "code": "-20403",
        "description": "该作品今天已经点过赞"
      }, {
        "code": "-20404",
        "description": "每个体型每天只能点赞3次"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获奖作品集列表
		请求方法: GET, POST
		请求示例: http://<domain>/jxmobile2/nielian181210/get_prize_list?award_type=1

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "list": [
	            {
	                "id": 5,
	                "title": "测试",
	                "data": "xxxx",
	                "category": 1,
	                "game_nickname": "",
	                "tags": [
	                    "标签1",
	                    "标签2"
	                ],
	                "zone_name": "测试区",
	                "server_name": "测试服",
	                "like": 1,
	                "created_at": "2018-12-10 19:52:40",
	                "type": 2,
	                "pic_link": "http://7xq4h6.com1.z0.glb.clouddn.com/xsjgw/cpanel/9f/ce/9fcedead3c7e333de23e6669c5c4547c",
	                "wechat_nickname": "测试昵称",
	                "wechat_head_img_url": "http://wx.qlogo.cn/mmopen/mbdcgRg42DZtROPSTQBEyMRznpc20J6BzusAscCKjVOKVk9QoaCEQlkxAXZFEovCP38uaJKzzPibXeibz5oRs8oopvtkMuscoF/0",
	                "wechat_uid": "e04f8ce2b032b8c913fd6e9087ac7425"
	            }
	        ],
	        "session_id": "bdPucDNjoWinMhhTRlko7Oipc7TIMZTevzPxD1nL",
	        "request_id": "6e742194eaa5f0d30dd4c854226322e2114874c8"
	    }
	 }
		*/
  service.getPrizeList = function(award_type) {
    return request.jsonp(rootAddress + '/jxmobile2/nielian181210/get_prize_list', {
      award_type: award_type /*  是否获奖作品 0没有获奖 1优秀奖 2人气奖 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "list": "列表"
          },
          "data{}.list[]": {
            "category": "捏脸类别 1成女 2萝莉 3正太 4成男",
            "created_at": "创建时间",
            "data": "作品数据",
            "game_nickname": "角色昵称",
            "id": "ID",
            "like": "点赞数",
            "pic_link": "图片链接",
            "server_name": "服名称",
            "tags": "标签组",
            "title": "作品标题",
            "type": "类别 1商城正面截图 2游戏内时装截图",
            "wechat_head_img_url": "微信头像地址",
            "wechat_nickname": "微信头像昵称",
            "wechat_uid": "微信uid",
            "zone_name": "区名称"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10701",
        "description": "未知驱动"
      }, {
        "code": "-20501",
        "description": "获取类型错误"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		搜索作品接口
		请求方法: GET, POST
		请求示例: http://<domain>/jxmobile2/nielian181210/search_gallery?keyword=测试

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "total": 3,
	        "list": [
	            {
	                "id": 6,
	                "title": "测试",
	                "data": "xxxx",
	                "category": 1,
	                "tags": [
	                    "标签1",
	                    "标签2"
	                ],
	                "game_nickname": "",
	                "zone_name": "测试区",
	                "server_name": "测试服",
	                "like": 1,
	                "created_at": "2018-12-11 10:47:30",
	                "type": 2,
	                "pic_link": "http://7xq4h6.com1.z0.glb.clouddn.com/xsjgw/cpanel/9f/ce/9fcedead3c7e333de23e6669c5c4547c",
	                "is_like": 0,
	                "wechat_nickname": "",
	                "wechat_head_img_url": "",
	                "wechat_uid": "e04f8ce2b032b8c913fd6e9087ac7424"
	            }
	        ],
	        "session_id": "wJe1MmgaEyRwU9tHubMUoraXg4Pd38i0cL7fiWtD",
	        "request_id": "ec70ccea8aeb4243319bca396e16ad52cbbd45cb"
	    }
	 }
		*/
  service.searchGallery = function(keyword, page_num, page_size) {
    return request.jsonp(rootAddress + '/jxmobile2/nielian181210/search_gallery', {
      keyword: keyword /*  搜索关键字 */ ,
      page_num: page_num /*  页数 */ ,
      page_size: page_size /*  分页大小 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)",
            "list": "列表",
            "total": "列表总数"
          },
          "data{}.list[]": {
            "category": "捏脸类别 1成女 2萝莉 3正太 4成男",
            "created_at": "创建时间",
            "data": "作品数据",
            "game_nickname": "角色昵称",
            "id": "ID",
            "is_like": "是否点过赞 0否 1是",
            "like": "点赞数",
            "pic_link": "图片链接",
            "server_name": "服名称",
            "tags": "标签组",
            "title": "作品标题",
            "type": "类别 1商城正面截图 2游戏内时装截图",
            "wechat_head_img_url": "微信头像地址",
            "wechat_nickname": "微信头像昵称",
            "wechat_uid": "微信uid",
            "zone_name": "区名称"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10701",
        "description": "未知驱动"
      }, {
        "code": "-10801",
        "description": "请先微信授权"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获取标签组
		请求方法: GET, POST
		请求示例: http://<domain>/jxmobile2/nielian181210/get_tags?is_hot=1

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "tags": [
	            "测试标签1",
	            "测试标签2"
	        ],
	        "session_id": "CR91h5AhluhTwbTgK9DmkwFnhND1nC76xxCB0EvB",
	        "request_id": "eff556a7a6807563b9d955bc437b26f79ae8d567"
	    }
	 }
		*/
  service.getTags = function(is_hot) {
    return request.jsonp(rootAddress + '/jxmobile2/nielian181210/get_tags', {
      is_hot: is_hot /*  是否热门标签 0否 1是 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "tags": "标签组"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		根据uid获取微信用户信息
		请求方法: GET, POST
		请求示例: http://<domain>/jxmobile2/nielian181210/get_gallery_by_uid?uid=e04f8ce2b032b8c913fd6e9087ac7425

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "list": [
	            {
	                "id": 5,
	                "title": "测试",
	                "data": "xxxx",
	                "category": 2,
	                "tags": [
	                    "标签1",
	                    "标签2"
	                ],
	                "game_nickname": "",
	                "zone_name": "测试区",
	                "server_name": "测试服",
	                "like": 1,
	                "created_at": "2018-12-10 19:52:40",
	                "award_type": 1,
	                "status": 1,
	                "type": 2,
	                "pic_link": "http://7xq4h6.com1.z0.glb.clouddn.com/xsjgw/cpanel/9f/ce/9fcedead3c7e333de23e6669c5c4547c",
	                "is_like": 0,
	                "wechat_nickname": "测试昵称",
	                "wechat_head_img_url": "http://wx.qlogo.cn/mmopen/mbdcgRg42DZtROPSTQBEyMRznpc20J6BzusAscCKjVOKVk9QoaCEQlkxAXZFEovCP38uaJKzzPibXeibz5oRs8oopvtkMuscoF/0",
	                "wechat_uid": "e04f8ce2b032b8c913fd6e9087ac7425"
	            },
	            {
	                "id": 4,
	                "title": "测试",
	                "data": "xxxx",
	                "category": 1,
	                "tags": [
	                    "标签1",
	                    "标签2"
	                ],
	                "game_nickname": "",
	                "zone_name": "测试区",
	                "server_name": "测试服",
	                "like": 2,
	                "created_at": "2018-12-10 19:52:03",
	                "award_type": 1,
	                "status": 1,
	                "type": 2,
	                "pic_link": "http://7xq4h6.com1.z0.glb.clouddn.com/xsjgw/cpanel/9f/ce/9fcedead3c7e333de23e6669c5c4547c",
	                "is_like": 0,
	                "wechat_nickname": "测试昵称",
	                "wechat_head_img_url": "http://wx.qlogo.cn/mmopen/mbdcgRg42DZtROPSTQBEyMRznpc20J6BzusAscCKjVOKVk9QoaCEQlkxAXZFEovCP38uaJKzzPibXeibz5oRs8oopvtkMuscoF/0",
	                "wechat_uid": "e04f8ce2b032b8c913fd6e9087ac7425"
	            }
	        ],
	        "total": 2,
	        "total_like": 3,
	        "session_id": "ZCIjh4J3QryaEcQ3lyCBAhOcKVh8WyzSWqIsFATf",
	        "request_id": "408c28c11523c942d61500c46dd188fbd20014c7"
	    }
	 }
		*/
  service.getGalleryByUid = function(uid) {
    return request.jsonp(rootAddress + '/jxmobile2/nielian181210/get_gallery_by_uid', {
      uid: uid /*  微信uid */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)",
            "list": "列表",
            "total": "列表总数",
            "total_like": "全部作品总点赞数"
          },
          "data{}.list[]": {
            "award_type": "是否获奖作品 0没有获奖 1优秀奖 2人气奖",
            "category": "捏脸类别 1成女 2萝莉 3正太 4成男",
            "created_at": "创建时间",
            "data": "作品数据",
            "game_nickname": "角色昵称",
            "id": "ID",
            "is_like": "是否点过赞 0否 1是",
            "like": "点赞数",
            "pic_link": "图片链接",
            "server_name": "服名称",
            "status": "状态 -1审核不通过 0审核中 1审核通过",
            "tags": "标签组",
            "title": "作品标题",
            "type": "类别 1商城正面截图 2游戏内时装截图",
            "wechat_head_img_url": "微信头像地址",
            "wechat_nickname": "微信头像昵称",
            "wechat_uid": "微信uid",
            "zone_name": "区名称"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10701",
        "description": "未知驱动"
      }, {
        "code": "-10801",
        "description": "请先微信授权"
      }, {
        "code": "-20601",
        "description": "uid为空"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		当前用户各体型剩余上传数量
		请求方法: GET, POST
		请求示例: http://<domain>/jxmobile2/nielian181210/get_upload_left_time

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "1": 0,
	        "2": 2,
	        "3": 2,
	        "4": 2,
	        "session_id": "Mgcbq3UK0cQm5aaptcelYOM4U8iMbhMe3VOVQybi",
	        "request_id": "9d4baf56ff905e2392949ab4e885332881dcec0a"
	    }
	 }
		*/
  service.getUploadLeftTime = function() {
    return request.jsonp(rootAddress + '/jxmobile2/nielian181210/get_upload_left_time', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "0": "成女",
            "1": "萝莉",
            "2": "正太",
            "3": "成男",
            "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10801",
        "description": "请先微信授权"
      }]
      		*/
      return reject(response);
    });
  };
  return service;
}